import { v4 as uuid } from 'uuid/dist/index.js'

const CommonUtils = {
  addToDictionnary: (dictionnary, element, lifo = false) => {
    const newElement = { key: uuid(), value: element }
    if (lifo) {
      return [].concat(newElement, dictionnary)
    }
    return [].concat(dictionnary, newElement)
  },
  createDictionnaryEntry: (element) => ({ key: uuid(), value: element }),
  formatBytes (a, b = 2) { if (!+a) return '0 Bytes'; const c = 0 > b ? 0 : b, d = Math.floor(Math.log(a) / Math.log(1024)); return `${parseFloat((a / Math.pow(1024, d)).toFixed(c))} ${['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'][d]}` },
  pluralize: (val, words) => (val > 1 ? words.map(w => w.concat('s ')).toString().replace(/,/g, '') : words.join(' '))
}

export default CommonUtils
